import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import { delete_cookie, read_cookie } from 'sfcookies';
import jwt_decode from 'jwt-decode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import * as Yup from 'yup';
import { Badge } from 'react-bootstrap';
import {
    Backdrop, CircularProgress, createTheme, InputAdornment, TextField, Tooltip,
} from '@mui/material';
import Swal from 'sweetalert2';

const TOKEN = read_cookie( 'admin_pppcalc' );
const BASE_URL = process.env.REACT_APP_BASE_URL;
// toast.configure({
//   position: toast.POSITION.BOTTOM_RIGHT,
//     autoClose: 5000,
//   className: 'toast-container-cy',
// });
const util = {};
util.initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  address: "",
  country: "USA",
  city: "",
  state: "",
  zip: "",
}

Yup.addMethod(Yup.string, "phoneLenght", function (errorMessage) {
  return this.test(`test-phone-length`, errorMessage, function (value) {
    const { path, createError } = this;
    // const formatted = value.replace( /_/g, '' );
    const formatted = value?.replace(/[(_-\s)]/g, '');
    return (
      (formatted && formatted.length === 10 /*14*/) ||
      createError({ path, message: errorMessage })
    );
  });
});

Yup.addMethod(Yup.string, "zipLenght", function (errorMessage) {
  return this.test(`test-phone-length`, errorMessage, function (value) {
    const { path, createError } = this;
    const formatted = value?.replace(/^\d{5}$/g, '');
    return (
      (formatted && formatted.length === 5) ||
      createError({ path, message: errorMessage })
    );
  });
});


util.SignupSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('First name is required')
    .max(50, "First name must be max 50 characters")
    .min(2, "First name must be at least 2 characters"),
  lastName: Yup.string().required('Last name is required')
  .max(50, "Last name must be max 50 characters")
    .min(2, "Last name must be at least 2 characters"),
  email: Yup.string().email('Invalid email').required('Email is required'),
  phoneNumber: Yup.string().required('Phone number is required').phoneLenght("Invalid phone number"),
  address: Yup.string().required('Address is required'),
  country: Yup.string().required('Country is required'),
  city: Yup.string().required('City is required'),
  state: Yup.string().required('State is required'),
  zip: Yup.string().required('Zip code is required').matches(/^[0-9]+$/, "Must be only digits"),
});

util.yearsList = () => {
    const d = [];
    const thisYear = parseInt( new Date().toISOString().split( '-' )[0], 10 );
    for ( let x = thisYear; x > 1999; x-- ) {
        d.push( { payYear: x } );
    }
    return d;
};

util.capitalizeFirstCharacter = ( str ) =>  str.charAt( 0 ).toUpperCase() + str.slice( 1 );

util.formatPhone = ( phone ) => {
    if ( phone === null || phone === undefined ) return '';
    const { length } = phone;
    if ( length > 10 ) {
        switch ( length ) {
            case 11:
                return (
                    `+${phone.slice( 0, 1 )
                    } (${phone.slice( 1, 4 )
                    }) ${phone.slice( 4, 7 )
                    } ${phone.slice( 7, 11 )}`
                );
            case 12:
                return (
                    `+${phone.slice( 0, 2 )
                    } (${phone.slice( 2, 5 )
                    }) ${phone.slice( 5, 8 )
                    } ${phone.slice( 8, 12 )}`
                );
            case 13:
                return (
                    `+${phone.slice( 0, 2 )
                    } (${phone.slice( 2, 5 )
                    }) ${phone.slice( 5, 8 )
                    } ${phone.slice( 8, 12 )}`
                );
            default: return phone;
        }
    } else {
        return phone;
    }
};

util.currencyFormat = ( value, country ) => {
    if ( !util.noValues.includes( value ) ) {
        let a = parseFloat( value ).toLocaleString( 'en-US', {
            style: 'currency',
            currency: 'USD',
        } );
        a = a.split( '$' );
        return `${util.symbolDependingCurrencySelected( country )} ${a[1]}`;
    }
    return `${util.symbolDependingCurrencySelected( country )} 0.00`;
};

util.symbolDependingCurrencySelected = ( country ) => {
    const currencySymbols = [
        { country: 'USA', symbol: '$' },
        { country: 'Mexico', symbol: 'MX$' },
        { country: 'Canada', symbol: 'CA$' },
        { country: 'Australia', symbol: 'AU$' },
        { country: 'India', symbol: '₹' },
        { country: 'Japan', symbol: '¥' },
    ];

    for ( let x = 0; x < currencySymbols.length; x++ ) {
        const c = currencySymbols[x];
        if ( c.country === country ) {
            return c.symbol;
        }
    }
    return '$';
};

util.whatsapp = ( tel, msg ) => `https://api.whatsapp.com/send?phone=${tel}&text=${encodeURI( msg )}`;

util.LOADING_SCREEN = function ( loading ) {
    return (
        <Backdrop open={loading} style={{ zIndex: 50000 }} addEndListener={null}>
            <div className="text-center custom-loader">
                <CircularProgress />
            </div>
        </Backdrop>
    );
};

util.zeroPad = ( num, places ) => String( num ).padStart( places, '0' );

util.user = read_cookie( 'admin_pppcalc' ).length > 0 ? jwt_decode( read_cookie( 'admin_pppcalc' ) ) : {};

util.isAdmin = read_cookie( 'anchor' ).length > 0 ? jwt_decode( read_cookie( 'anchor' ) ) : {};

util.baseUrl = () => BASE_URL;

util.handleError = ( msg ) => {
    if ( process.env.ENVIROMENT !== 'Production' ) console.log( msg );
    if ( msg.toString().indexOf( 'Unauthorized' ) !== -1 ) {
        setTimeout( () => {
            alert( 'Session expired' );
            delete_cookie( 'admin_pppcalc' );
            window.history.replaceState( '', '', '/' );
            window.location.reload();
        }, 1000 );
    } else if ( msg.toString().indexOf( '_UNIQUE' ) !== -1 ) {
        const emsg = msg.split( '_' );
        const field = emsg[0].split( '.' )[1];
        util.toast.error(
            `${field.toUpperCase()[0] + field.substr( 1 )} must be unique`,
        );
    } else if ( msg.toString().indexOf( 'notEmpty' ) !== -1 ) {
        const emsg = msg.split( ' ' );
        util.toast.error(
            `${emsg[3].toUpperCase()[0] + emsg[3].substr( 1 )} cannot be empty`,
        );
    } else if ( msg.toString().indexOf( 'isEmail' ) !== -1 ) {
        util.toast.error( 'Email is not valid' );
    } else {
        util.toast.error( msg );
    }
};

util.url = BASE_URL;

util.location = ( country, state, city ) => {
    let locationString = '';
    if ( city !== null && city !== '' ) {
        locationString += city;
    }
    if ( state !== null && state !== '' ) {
        locationString += `,${util.getStateAbbreviation( state )}`;
    }
    if ( country !== null && country !== '' ) {
        locationString += `,${util.getCountryAbbreviation( country )}`;
    }
    if ( locationString === '' ) {
        locationString = ' -- ';
    }
    return locationString;
};

util.axios = axios.create( {
    baseURL: BASE_URL,
    timeout: 30000,
    headers: { Authorization: `${TOKEN}` },
} );

util.axiosWithBearer  = axios.create( {
    baseURL: BASE_URL,
    timeout: 30000,
    headers: { Authorization: `Bearer ${TOKEN}` },
} );

util.axios.interceptors.response.use(
    response => {
        const { status } = response['data'];
        if ( status == 403 ) {
            delete_cookie( 'admin_pppcalc' );
            window.location.replace( "" );
            return Promise.reject( response['data'] );
        } else {
            return response;
        }
    },
    function ( error ) {
        if ( error.response.status === 403 ) {
            delete_cookie( 'admin_pppcalc' );
            window.location.replace( "" );
            return Promise.reject( error );
        } else {
            return error && error['response'];
        }
        // return Promise.reject(error)
    }
);

util.noValues = [null, 0, undefined, 'undefined', '0', ''];

util.toast = toast;
util.SwalCX = ( title, text, icon, confirmButton ) => Swal.fire( {
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: confirmButton,
} );

util.printPrettyDateTime = ( dateString ) => {
    console.log( dateString );
    const d = dateString.split( 'T' )[0];
    const realData = util.humanDate( d );
    const time = dateString.split( 'T' )[1].split( '.' )[0];
    return <>
        <div>{realData}</div>
        <div>{time}</div>
    </>;
};

const moment = require( 'moment' );

util.timeAgo = ( dateString ) => {
    return moment( dateString ).fromNow();
};


util.humanDate = ( date, str = false, longStr = false ) => {
    if ( date === null ) return date;
    const d = date.split( 'T' )[0].split( '-' );
    let month = d[1];
    if ( str ) {
        // Want name of the month instead of the number
        switch ( d[1] ) {
            case '01':
                month = longStr ? 'January' : 'Jan';
                break;
            case '02':
                month = longStr ? 'February' : 'Feb';
                break;
            case '03':
                month = longStr ? 'March' : 'Mar';
                break;
            case '04':
                month = longStr ? 'April' : 'Apr';
                break;
            case '05':
                month = longStr ? 'May' : 'May';
                break;
            case '06':
                month = longStr ? 'June' : 'Jun';
                break;
            case '07':
                month = longStr ? 'July' : 'Jul';
                break;
            case '08':
                month = longStr ? 'August' : 'Aug';
                break;
            case '09':
                month = longStr ? 'September' : 'Sep';
                break;
            case '10':
                month = longStr ? 'October' : 'Oct';
                break;
            case '11':
                month = longStr ? 'November' : 'Nov';
                break;
            case '12':
                month = longStr ? 'December' : 'Dec';
                break;
            default:
                const [index1] = d;
                month = index1;
                break;
        }
    }

    // return <Badge variant="info">{finalDate}</Badge>
    return `${month}/${d[2]}/${d[0]}`;
};

/**
 * Function to get current date in "YYYY-MM-DD" format
 * @return {year} String
 * @return {month} String
 * @return {day} String
 * @return {String} Object
 */
util.getCustomDateFormat = ( year, month ) => {
    if ( month ) {
        switch ( month ) {
            case 'January':
                month = '01';
                break;
            case 'February':
                month = '02';
                break;
            case 'March':
                month = '03';
                break;
            case 'April':
                month = '04';
                break;
            case 'May':
                month = '05';
                break;
            case 'June':
                month = '06';
                break;
            case 'July':
                month = '07';
                break;
            case 'August':
                month = '08';
                break;
            case 'September':
                month = '09';
                break;
            case 'October':
                month = '10';
                break;
            case 'November':
                month = '11';
                break;
            case 'December':
                month = '12';
                break;
            default:
                const today = new Date();
                let current_month = today.getMonth() + 1;

                if ( current_month < 10 ) {
                    current_month = `0${current_month}`;
                }
                month = current_month;
                break;
        }
    }
    const lastDay = new Date( year, month, 0 ).getDate();
    return { start: `${year}-${month}-01`, end: `${year}-${month}-${lastDay}` };
};

util.defaultTableTheme = createTheme( {
    palette: {
        primary: {
            main: '#2d78e9',
        },
        secondary: {
            main: '#2196F3',
        },
    },
    overrides: {
        MuiTableCell: {
            root: {
                padding: 3,
                fontSize: 13,
            },
            head: {
                textAlign: 'center!important',
                textDecoration: 'none',
                lineHeight: 1,
                backgroundColor: 'dodgerblue!important',
                color: 'white',
            },
        },
    },
} );

util.formatter = new Intl.NumberFormat( 'en-US', {
    style: 'currency',
    currency: 'USD',
} );

util.client = {
    address: '',
    city: '',
    country: '',
    email: '',
    name: '',
    phone1: '',
    phone2: '',
    picture: '',
    state: '',
    updatedAt: '',
    zip_code: '',
};

util.items = [
    {
        name: '',
        description: '',
        qty: 1,
        price: '0.0',
    },
];

util.product = {
    id: Math.round( Math.random() * Math.random() * 99 ),
    name: '',
    description: '',
    qty: 1,
    price: '0',
};

util.defaultTableTheme = createTheme( {
    palette: {
        // primary: {
        //     main: '#2196F3',
        // },
        // secondary: {
        //     main: '#2196F3',
        // }
    },
    overrides: {
        MuiTableCell: {
            root: {
                // padding:3,
                fontSize: 13,
                backgroundColor: 'transparent',
            },
            head: {
                textAlign: 'center!important',
                textDecoration: 'none',
                lineHeight: 1,
            },
            body: {
                fontSize: '13px!important',
            },
        },
    },
} );

util.RowComponent = function ( {
    type, af, c, d, disabled, error, errorText, ic, m, max, min, mul, n, onPaste, t, ty, v, variant, divClassName
} ) {
    if ( type === undefined ) {
        return (
            <div className={`col-md-${c} p-1 mt-2 ${divClassName}`}>
                <TextField
                    disabled={disabled || false}
                    multiline={mul !== undefined}
                    rows={mul ? 5 : 1}
                    className={`w-100`}
                    size="small"
                    fullWidth
                    onInput={( e ) => {
                        e.target.value = e.target.value.toString().slice( 0, 55 );
                    }}
                    onPaste={( e ) => ( onPaste ? onPaste( e ) : null )}
                    id={n}
                    error={!!error}
                    helperText={errorText || ''}
                    autoFocus={af !== undefined}
                    InputLabelProps={{ shrink: true }}
                    value={v}
                    type={ty || ''}
                    label={t}
                    variant={variant || 'outlined'}
                    name={n}
                    onChange={m}
                    InputProps={
                        ic
                            ? {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FontAwesomeIcon icon={faDollarSign} />
                                    </InputAdornment>
                                ),
                                inputProps:
                                    min && max
                                        ? {
                                            min,
                                            max,
                                        }
                                        : {},
                            }
                            : {
                                inputProps:
                                    min && max
                                        ? {
                                            min,
                                            max,
                                        }
                                        : {},
                            }
                    }
                />
            </div>
        );
    }
    return (
        <div className={`col-md-${c} p-1 mt-2`}>
            <TextField
                fullWidth
                id={n}
                disabled={disabled || false}
                select
                variant={variant || 'standard'}
                name={n}
                className="w-100"
                size="small"
                label={t}
                value={v || 'None'}
                onChange={m}
                InputLabelProps={{ shrink: true }}
                SelectProps={{
                    native: true,
                }}
            >
                <option value=""> --</option>
                {d.map( ( option ) => (
                    <option key={Math.random()} value={option[n]}>
                        {option[n]}
                    </option>
                ) )}
            </TextField>
        </div>
    );
};

util.cleanValues = ( value ) => {
    return value.replace( /[$,()"]/g, '' );
};

util.onlyNumber = ( value ) => {
    let valueTemp = value;
    const invalidChars = /[^\d.]|\.(?=.*\.)/g;
    if ( invalidChars.test( valueTemp ) ) {
        valueTemp = valueTemp.replace( invalidChars, "" );
    }
    return valueTemp;
};

util.RowComponentBS = function ( {
    c, disabled, m, max, min, n, onKeyDown, d, t, ty, type, v, divClassName
} ) {
    if ( type === undefined ) {
        return (
            <div className={`col-md-${c} ${divClassName || 'p-1 mt-2'}`}>
                <label htmlFor={n}>{t}</label>
                <input
                    onInput={( e ) => {
                        e.target.value = e.target.value.toString().slice( 0, 55 );
                    }}
                    disabled={disabled || false}
                    className="w-100 form-control"
                    id={n}
                    onKeyDown={( e ) => {
                        if ( e.keyCode === 13 && onKeyDown ) {
                            // onKeyDownMethod(e).then(r => null)
                        }
                    }}
                    value={v}
                    min={min && ty === 'date' ? min : null}
                    max={max && ty === 'date' ? max : null}
                    type={ty || ''}
                    name={n}
                    onChange={m}
                />
            </div>
        );
    }
    return (
        <div className={`col-md-${c} ${divClassName || 'p-1 mt-2'}`}>
            <label htmlFor={n}>{t}</label>
            <select
                id={n}
                disabled={disabled || false}
                name={n}
                className="w-100 form-control"
                value={v || 'None'}
                onChange={m}
            >
                <option value=""> --</option>
                {d.map( ( option ) => (
                    <option key={option[n]} value={option[n]}>
                        {option[n]}
                    </option>
                ) )}
            </select>
        </div>
    );
};

util.nameToInitials = ( d ) => {
    let letters;
    if ( d.created_by === null || d.created_by === '' ) {
        letters = '--';
    } else {
        const name = d.created_by.split( ' ' );
        if ( name.length === 1 ) {
            letters = name[0] + name[1];
        } else {
            letters = name[0][0] + name[1][0];
        }
    }
    return (
        <Tooltip title={d.created_by || 'Unknown'}>
            <center>
                <span data-letters={letters} />
            </center>
        </Tooltip>
    );
};

util.country = () => [
    { country: 'USA', id: 1, abbreviation: 'US' },
    // { country: 'Canada', id: 2, abbreviation: 'CA' },
    // { country: 'Mexico', id: 3, abbreviation: 'MX' },
    // { country: 'India', id: 4, abbreviation: 'IN' },
    // { country: 'Australia', id: 5, abbreviation: 'AU' },
];

util.getStateAbbreviation = ( state ) => {
    for ( let x = 0; x < util.states.length; x++ ) {
        if ( state === util.states[x].state ) {
            return util.states[x].abbreviation;
        }
    }
    return null;
};

util.getCountryAbbreviation = ( country ) => {
    const countries = util.country();
    for ( let x = 0; x < countries.length; x++ ) {
        if ( country === countries[x].country ) {
            return countries[x].abbreviation;
        }
    }
    return null;
};

function numberWithCommas( x ) {
    const parts = x.toString().split( '.' );
    parts[0] = parts[0].replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
    return parts.join( '.' );
}

util.currencyFormat = ( valueInput ) => {
    if ( valueInput === null ) {
        return '$0.0';
    }
    const value = parseFloat( valueInput ).toFixed( 2 );
    if ( value ) {
        return `$ ${numberWithCommas( value )}`;
    }
    return '$0.0';
};

util.USA_STATES = [
  { name: 'ALABAMA', abbreviation: 'AL' },
  { name: 'ALASKA', abbreviation: 'AK' },
  { name: 'AMERICAN SAMOA', abbreviation: 'AS' },
  { name: 'ARIZONA', abbreviation: 'AZ' },
  { name: 'ARKANSAS', abbreviation: 'AR' },
  { name: 'CALIFORNIA', abbreviation: 'CA' },
  { name: 'COLORADO', abbreviation: 'CO' },
  { name: 'CONNECTICUT', abbreviation: 'CT' },
  { name: 'DELAWARE', abbreviation: 'DE' },
  { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
  { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
  { name: 'FLORIDA', abbreviation: 'FL' },
  { name: 'GEORGIA', abbreviation: 'GA' },
  { name: 'GUAM', abbreviation: 'GU' },
  { name: 'HAWAII', abbreviation: 'HI' },
  { name: 'IDAHO', abbreviation: 'ID' },
  { name: 'ILLINOIS', abbreviation: 'IL' },
  { name: 'INDIANA', abbreviation: 'IN' },
  { name: 'IOWA', abbreviation: 'IA' },
  { name: 'KANSAS', abbreviation: 'KS' },
  { name: 'KENTUCKY', abbreviation: 'KY' },
  { name: 'LOUISIANA', abbreviation: 'LA' },
  { name: 'MAINE', abbreviation: 'ME' },
  { name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
  { name: 'MARYLAND', abbreviation: 'MD' },
  { name: 'MASSACHUSETTS', abbreviation: 'MA' },
  { name: 'MICHIGAN', abbreviation: 'MI' },
  { name: 'MINNESOTA', abbreviation: 'MN' },
  { name: 'MISSISSIPPI', abbreviation: 'MS' },
  { name: 'MISSOURI', abbreviation: 'MO' },
  { name: 'MONTANA', abbreviation: 'MT' },
  { name: 'NEBRASKA', abbreviation: 'NE' },
  { name: 'NEVADA', abbreviation: 'NV' },
  { name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
  { name: 'NEW JERSEY', abbreviation: 'NJ' },
  { name: 'NEW MEXICO', abbreviation: 'NM' },
  { name: 'NEW YORK', abbreviation: 'NY' },
  { name: 'NORTH CAROLINA', abbreviation: 'NC' },
  { name: 'NORTH DAKOTA', abbreviation: 'ND' },
  { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP' },
  { name: 'OHIO', abbreviation: 'OH' },
  { name: 'OKLAHOMA', abbreviation: 'OK' },
  { name: 'OREGON', abbreviation: 'OR' },
  { name: 'PALAU', abbreviation: 'PW' },
  { name: 'PENNSYLVANIA', abbreviation: 'PA' },
  { name: 'PUERTO RICO', abbreviation: 'PR' },
  { name: 'RHODE ISLAND', abbreviation: 'RI' },
  { name: 'SOUTH CAROLINA', abbreviation: 'SC' },
  { name: 'SOUTH DAKOTA', abbreviation: 'SD' },
  { name: 'TENNESSEE', abbreviation: 'TN' },
  { name: 'TEXAS', abbreviation: 'TX' },
  { name: 'UTAH', abbreviation: 'UT' },
  { name: 'VERMONT', abbreviation: 'VT' },
  { name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
  { name: 'VIRGINIA', abbreviation: 'VA' },
  { name: 'WASHINGTON', abbreviation: 'WA' },
  { name: 'WEST VIRGINIA', abbreviation: 'WV' },
  { name: 'WISCONSIN', abbreviation: 'WI' },
  { name: 'WYOMING', abbreviation: 'WY' }
]


util.states = [
    { country_id: 1, state: 'Alabama', abbreviation: 'AL' },
    { country_id: 1, state: 'Alaska', abbreviation: 'AK' },
    { country_id: 1, state: 'Arizona', abbreviation: 'AZ' },
    { country_id: 1, state: 'Arkansas', abbreviation: 'AR' },
    { country_id: 1, state: 'California', abbreviation: 'CA' },
    { country_id: 1, state: 'Colorado', abbreviation: 'CO' },
    { country_id: 1, state: 'Connecticut', abbreviation: 'CT' },
    { country_id: 1, state: 'Delaware', abbreviation: 'DE' },
    { country_id: 1, state: 'Florida', abbreviation: 'FL' },
    { country_id: 1, state: 'Georgia', abbreviation: 'GA' },
    { country_id: 1, state: 'Hawaii', abbreviation: 'HI' },
    { country_id: 1, state: 'Idaho', abbreviation: 'ID' },
    { country_id: 1, state: 'Illinois', abbreviation: 'IL' },
    { country_id: 1, state: 'Indiana', abbreviation: 'IN' },
    { country_id: 1, state: 'Iowa', abbreviation: 'IA' },
    { country_id: 1, state: 'Kansas', abbreviation: 'KS' },
    { country_id: 1, state: 'Kentucky', abbreviation: 'KY' },
    { country_id: 1, state: 'Louisiana', abbreviation: 'LA' },
    { country_id: 1, state: 'Maine', abbreviation: 'ME' },
    { country_id: 1, state: 'Maryland', abbreviation: 'MD' },
    { country_id: 1, state: 'Massachusetts', abbreviation: 'MA' },
    { country_id: 1, state: 'Michigan', abbreviation: 'MI' },
    { country_id: 1, state: 'Minnesota', abbreviation: 'MN' },
    { country_id: 1, state: 'Mississippi', abbreviation: 'MS' },
    { country_id: 1, state: 'Missouri', abbreviation: 'MO' },
    { country_id: 1, state: 'Montana', abbreviation: 'MT' },
    { country_id: 1, state: 'Nebraska', abbreviation: 'NE' },
    { country_id: 1, state: 'Nevada', abbreviation: 'NV' },
    { country_id: 1, state: 'New Hampshire', abbreviation: 'NH' },
    { country_id: 1, state: 'New Jersey', abbreviation: 'NJ' },
    { country_id: 1, state: 'New Mexico', abbreviation: 'NM' },
    { country_id: 1, state: 'New York', abbreviation: 'NY' },
    { country_id: 1, state: 'North Carolina', abbreviation: 'NC' },
    { country_id: 1, state: 'North Dakota', abbreviation: 'ND' },
    { country_id: 1, state: 'Ohio', abbreviation: 'OH' },
    { country_id: 1, state: 'Oklahoma', abbreviation: 'OK' },
    { country_id: 1, state: 'Oregon', abbreviation: 'OR' },
    { country_id: 1, state: 'Pennsylvania', abbreviation: 'PA' },
    { country_id: 1, state: 'Rhode Island', abbreviation: 'RI' },
    { country_id: 1, state: 'South Carolina', abbreviation: 'SC' },
    { country_id: 1, state: 'South Dakota', abbreviation: 'SD' },
    { country_id: 1, state: 'Tennessee', abbreviation: 'TN' },
    { country_id: 1, state: 'Texas', abbreviation: 'TX' },
    { country_id: 1, state: 'Utah', abbreviation: 'UT' },
    { country_id: 1, state: 'Vermont', abbreviation: 'VT' },
    { country_id: 1, state: 'Virginia', abbreviation: 'VA' },
    { country_id: 1, state: 'Washington', abbreviation: 'WA' },
    { country_id: 1, state: 'West Virginia', abbreviation: 'WV' },
    { country_id: 1, state: 'Wisconsin', abbreviation: 'WI' },
    { country_id: 1, state: 'Wyoming', abbreviation: 'WY' },
    { country_id: 2, state: 'Alberta', abbreviation: 'AB' },
    { country_id: 2, state: 'British Columbia', abbreviation: 'BC' },
    { country_id: 2, state: 'Manitoba', abbreviation: 'MB' },
    { country_id: 2, state: 'New Brunswick', abbreviation: 'NB' },
    { country_id: 2, state: 'Newfoundland and Labrador', abbreviation: 'NL' },
    { country_id: 2, state: 'Northwest Territories', abbreviation: 'NT' },
    { country_id: 2, state: 'Nova Scotia', abbreviation: 'NS' },
    { country_id: 2, state: 'Nunavut', abbreviation: 'NU' },
    { country_id: 2, state: 'Ontario', abbreviation: 'ON' },
    { country_id: 2, state: 'Prince Edward Island', abbreviation: 'PE' },
    { country_id: 2, state: 'Quebec', abbreviation: 'QC' },
    { country_id: 2, state: 'Saskatchewan', abbreviation: 'SK' },
    { country_id: 2, state: 'Yukon', abbreviation: 'YT' },
    { country_id: 3, state: 'Aguascalientes', abbreviation: 'AG' },
    { country_id: 3, state: 'Baja California', abbreviation: 'BC' },
    { country_id: 3, state: 'Baja California Sur', abbreviation: 'BS' },
    { country_id: 3, state: 'Campeche', abbreviation: 'CM' },
    { country_id: 3, state: 'Chiapas', abbreviation: 'CS' },
    { country_id: 3, state: 'Chihuahua', abbreviation: 'CH' },
    { country_id: 3, state: 'Coahuila', abbreviation: 'CO' },
    { country_id: 3, state: 'Colima', abbreviation: 'CL' },
    { country_id: 3, state: 'Durango', abbreviation: 'DG' },
    { country_id: 3, state: 'Guanajuato', abbreviation: 'GT' },
    { country_id: 3, state: 'Guerrero', abbreviation: 'GR' },
    { country_id: 3, state: 'Hidalgo', abbreviation: 'HG' },
    { country_id: 3, state: 'Jalisco', abbreviation: 'JA' },
    { country_id: 3, state: 'Mexico', abbreviation: 'EM' },
    { country_id: 3, state: 'Michoacan', abbreviation: 'MI' },
    { country_id: 3, state: 'Morelos', abbreviation: 'MO' },
    { country_id: 3, state: 'Nayarit', abbreviation: 'NA' },
    { country_id: 3, state: 'Nuevo Leon', abbreviation: 'NL' },
    { country_id: 3, state: 'Oaxaca', abbreviation: 'OA' },
    { country_id: 3, state: 'Puebla', abbreviation: 'PU' },
    { country_id: 3, state: 'Queretaro', abbreviation: 'QT' },
    { country_id: 3, state: 'Quintana Roo', abbreviation: 'QR' },
    { country_id: 3, state: 'San Luis Potosi', abbreviation: 'SL' },
    { country_id: 3, state: 'Sinaloa', abbreviation: 'SI' },
    { country_id: 3, state: 'Sonora', abbreviation: 'SO' },
    { country_id: 3, state: 'Tabasco', abbreviation: 'TB' },
    { country_id: 3, state: 'Tamaulipas', abbreviation: 'TL' },
    { country_id: 3, state: 'Tlaxcala', abbreviation: 'TM' },
    { country_id: 3, state: 'Veracruz', abbreviation: 'VE' },
    { country_id: 3, state: 'Yucatan', abbreviation: 'YU' },
    { country_id: 3, state: 'Zacatecas', abbreviation: 'ZA' },
    { country_id: 4, state: 'Andhra Pradesh', abbreviation: 'AD' },
    { country_id: 4, state: 'Arunachal Pradesh', abbreviation: 'AR' },
    { country_id: 4, state: 'Assam', abbreviation: 'AS' },
    { country_id: 4, state: 'Bihar', abbreviation: 'BR' },
    { country_id: 4, state: 'Chattisgarh', abbreviation: 'CG' },
    { country_id: 4, state: 'Delhi', abbreviation: 'DL' },
    { country_id: 4, state: 'Goa', abbreviation: 'GA' },
    { country_id: 4, state: 'Gujarat', abbreviation: 'GJ' },
    { country_id: 4, state: 'Haryana', abbreviation: 'HR' },
    { country_id: 4, state: 'Himachal Pradesh', abbreviation: 'HP' },
    { country_id: 4, state: 'Jammu and Kashmir', abbreviation: 'JK' },
    { country_id: 4, state: 'Jharkhand', abbreviation: 'JH' },
    { country_id: 4, state: 'Karnataka', abbreviation: 'KA' },
    { country_id: 4, state: 'Kerala', abbreviation: 'KL' },
    { country_id: 4, state: 'Lakshadweep Islands', abbreviation: 'LD' },
    { country_id: 4, state: 'Madhya Pradesh', abbreviation: 'MP' },
    { country_id: 4, state: 'Maharashtra', abbreviation: 'MH' },
    { country_id: 4, state: 'Manipur', abbreviation: 'MN' },
    { country_id: 4, state: 'Meghalaya', abbreviation: 'ML' },
    { country_id: 4, state: 'Mizoram', abbreviation: 'MZ' },
    { country_id: 4, state: 'Nagaland', abbreviation: 'NL' },
    { country_id: 4, state: 'Odisha', abbreviation: 'OD' },
    { country_id: 4, state: 'Pondicherry', abbreviation: 'PY' },
    { country_id: 4, state: 'Punjab', abbreviation: 'PB' },
    { country_id: 4, state: 'Rajasthan', abbreviation: 'RJ' },
    { country_id: 4, state: 'Sikkim', abbreviation: 'SK' },
    { country_id: 4, state: 'Tamil Nadu', abbreviation: 'TN' },
    { country_id: 4, state: 'Telangana', abbreviation: 'TS' },
    { country_id: 5, state: 'New South Wales', abbreviation: 'xx' },
    { country_id: 5, state: 'Queensland', abbreviation: 'xx' },
    { country_id: 5, state: 'South Australia', abbreviation: 'xx' },
    { country_id: 5, state: 'Tasmania', abbreviation: 'xx' },
    { country_id: 5, state: 'Victoria', abbreviation: 'xx' },
    { country_id: 5, state: 'Western Australia', abbreviation: 'xx' },
];

util.randomStringId = ( length ) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters
            .charAt( Math.floor( Math.random() * charactersLength ) )
            .toUpperCase();
    }
    return result;
};

util.expirationDate = ( numWeeks ) => {
    const now = new Date();
    now.setDate( now.getDate() + numWeeks * 7 );
    return now.toDateString().slice( 4 );
};

util.salesActivityObj = () => ( {
    quarter: '',
    year: parseInt( new Date().toISOString().split( '-' )[0], 10 ).toString(),
    grossSale: 0,
    useTaxPurchases: 0,
    dieselTaxes: 0,
    fixtureAndEquipmentSales: 0,
    otherRetailerResales: 0,
    nonTaxableSales: 0,
    nonTaxableLabor: 0,
    governmentSales: 0,
    interForeignSales: 0,
    salesTaxIncGrossSales: 0,
    otherDeductions: 0,
    taxRecoveryAdjustment: 0,
    transSubjToCountry: 0,
    airLocalTaxAdj: 0,
    transSubjToLocation: 0,
    districtTax: 0,
    taxPaidToOtherState: 0,
    excessTax: 0,
    prepayment1: 0,
    prepayment2: 0,
    prepaidFuel: 0,
    partialExemptCredit: 0,
    penalty: 0,
    interest: 0,
    nonTaxFoodProd: 0,
    reportedTotalSalesExTaxExTip: 0,
    reportedTotalSalesExTax: 0,
    stateTax: 0,
    countyTax: 0,
    localTax: 0,
    salesTaxIncludedFITR: 0,
} );

util.bank_deposit = () => ( {
    date: '',
    deposit: 0,
    equity: 0,
    bank_transfer: 0,
    other: 0,
    selectedColumn: 'other'
} );

util.federal_income_tax = () => ( {
    client_id: 0,
    year: 0,
    grossReceipts: 0,
    beginningInventory: 0,
    purchases: 0,
    costOfLabor: 0,
    otherCost: 0,
    endingInventory: 0,
    costOfGoodsSold: 0,
    otherIncome: 0,
    compensationToOfficers: 0,
    salariesAndWages: 0,
    repairsAndMaintenance: 0,
    badDebts: 0,
    rents: 0,
    taxesAndLicenses: 0,
    interest: 0,
    charitableContributions: 0,
    depreciation: 0,
    depletion: 0,
    advertising: 0,
    pensionProfitSharing: 0,
    employeeBenefitPrograms: 0,
    otherDeductions: 0,
    branch_id: 0,
} );

util.creditCardRecord = () => ( {
    reqAcctNbr: 0,
    acctNo: 0,
    payeeTIN: 0,
    payerName: '',
    payeeAcctNo: '',
    payeeName1: '',
    payeeName2: '',
    payeeStr: '',
    payeeCity: '',
    payeeState: '',
    payeeZip: 0,
    payYear: '',
    grossPmts: 0,
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dec: 0,
    t1099YrSum: 0,
    boeyrGross: 0,
    t1099: 0,
} );

util.generateYears = () => {
    const years = [];
    const currentYear = parseInt( new Date().toISOString().split( '-' )[0], 10 );
    for ( let x = currentYear; x > 1999; x-- ) {
        years.push( { year: x } );
    }
    return years;
};

util.validateEmail = ( email ) => {
    const re = /\S+@\S+\.\S+/;
    return re.test( email );
};

util.humanRole = ( role ) => {
    switch ( role ) {
        case 1:
            return <Badge variant="success">Admin</Badge>;
        case 2:
            return <Badge variant="success">Subscriber</Badge>;
        case 3:
            return <Badge variant="success">Client</Badge>;
        case 4:
            return <Badge variant="success">Helper</Badge>;
        default: return '';
    }
};

util.salesActivityFixed = ( sales_activity ) => {
    if ( sales_activity !== undefined && sales_activity.length > 0 ) {
        let arrayYears = sales_activity.map( ( s ) => s.year );
        arrayYears = [...new Set( arrayYears )];
        const final = [];
        for ( let x = 0; x < arrayYears.length; x++ ) {
            const f = { year: arrayYears[x] };
            const tempArray = [];
            for ( let y = 0; y < sales_activity.length; y++ ) {
                if ( sales_activity[y].year === arrayYears[x] ) {
                    tempArray.push( sales_activity[y] );
                }
            }
            f.data = tempArray;
            final.push( f );
        }
        return final;
    }
    return null;
};

util.bankDepositsFixed = ( bank_deposit ) => {
    if ( bank_deposit !== undefined && bank_deposit.length > 0 ) {
        let arrayYears = bank_deposit.map( ( s ) => s.date.split( '-' )[0] );
        arrayYears = [...new Set( arrayYears )];
        const final = [];
        for ( let x = 0; x < arrayYears.length; x++ ) {
            const f = { year: arrayYears[x] };
            const tempArray = [];
            for ( let y = 0; y < bank_deposit.length; y++ ) {
                if ( bank_deposit[y].date.split( '-' )[0] === arrayYears[x] ) {
                    tempArray.push( bank_deposit[y] );
                }
            }
            tempArray.sort( ( a, b ) => new Date( a.date ) - new Date( b.date ) );
            f.data = tempArray;
            final.push( f );
        }
        return final;
    }
    return null;
};

util.creditCardRecordFixed = ( bank_deposit ) => {
    if ( bank_deposit.length > 0 ) {
        let arrayYears = bank_deposit.map( ( s ) => s.date.split( '-' )[0] );
        arrayYears = [...new Set( arrayYears )];
        const final = [];
        for ( let x = 0; x < arrayYears.length; x++ ) {
            const f = { year: arrayYears[x] };
            const tempArray = [];
            for ( let y = 0; y < bank_deposit.length; y++ ) {
                if ( bank_deposit[y].date.split( '-' )[0] === arrayYears[x] ) {
                    tempArray.push( bank_deposit[y] );
                }
            }
            tempArray.sort( ( a, b ) => new Date( a.date ) - new Date( b.date ) );
            f.data = tempArray;
            final.push( f );
        }
        return final;
    }
    return null;
};

util.federalIncomeTaxesFixed = ( income_taxes ) => {
    if ( income_taxes.length > 0 ) {
        let arrayYears = income_taxes.map( ( s ) => s.year );
        arrayYears = [...new Set( arrayYears )];
        const final = [];
        for ( let x = 0; x < arrayYears.length; x++ ) {
            const f = { year: arrayYears[x] };
            const tempArray = [];
            for ( let y = 0; y < income_taxes.length; y++ ) {
                if ( income_taxes[y].year === arrayYears[x] ) {
                    tempArray.push( income_taxes[y] );
                }
            }
            tempArray.sort( ( a, b ) => new Date( a.year ) - new Date( b.year ) );
            f.data = tempArray;
            final.push( f );
        }
        return final;
    }
    return null;
};

util.fixDate = ( date ) => date.toISOString().split( 'T' )[0];

util.claimedReductions = {
    total: 1600,
    data: [
        {
            total: 400,
            year: 2015,
            quarters: [
                {
                    quarter: 'Q4',
                    value: 100,
                },
                {
                    quarter: 'Q3',
                    value: 100,
                },
                {
                    quarter: 'Q2',
                    value: 100,
                },
                {
                    quarter: 'Q1',
                    value: 100,
                },
            ],
        },
        {
            total: 400,
            year: 2016,
            quarters: [
                {
                    quarter: 'Q4',
                    value: 100,
                },
                {
                    quarter: 'Q3',
                    value: 100,
                },
                {
                    quarter: 'Q2',
                    value: 100,
                },
                {
                    quarter: 'Q1',
                    value: 100,
                },
            ],
        },
        {
            total: 400,
            year: 2017,
            quarters: [
                {
                    quarter: 'Q4',
                    value: 100,
                },
                {
                    quarter: 'Q3',
                    value: 100,
                },
                {
                    quarter: 'Q2',
                    value: 100,
                },
                {
                    quarter: 'Q1',
                    value: 100,
                },
            ],
        },
    ],
};

util.score = {
    score: 86.56,
    bank_deposit: {
        up: 31675.13,
        down: 1560432.48,
        percentage: 1 - 31675.13 / 1560432.48,
        settings: {
            urgentAttention: 85,
            needsAttentionMin: 95,
            perfect: 98,
        },
    },
    audited_sales: {
        up: 1592085.84,
        down: 1592107.63,
        percentage: 1 - 1592085.84 / 1592107.63,
        settings: {
            urgentAttention: 75,
            needsAttentionMin: 95,
            perfect: 110,
        },
    },
    federal_income_tax: {
        up: 635800,
        down: 159107.63,
        percentage: 1 - 635800 / 159107.63,
        settings: {
            urgentAttention: 85,
            needsAttentionMin: 90,
            perfect: 100,
        },
    },
    grossProfit: {
        up: 635800,
        down: 1592107.63,
        percentage: 1 - 635800 / 1592107.63,
    },
    ebitda: {
        up: 1123522.3,
        down: 1592107.63,
        percentage: 1 - 1123522.3 / 1592107.63,
    },
};

util.randomString = () => Math.random()
    .toString( 36 )
    .replace( /[^a-z]+/g, '' )
    .substr( 0, 8 );


util.getMonthNameFromDate = ( date = null ) => {
    if ( date === null ) return '';
    const d = date.split( "-" );
    switch ( parseInt( d[1] ) ) {
        case 1: return 'January';
        case 2: return 'February';
        case 3: return 'March';
        case 4: return 'April';
        case 5: return 'May';
        case 6: return 'June';
        case 7: return 'July';
        case 8: return 'August';
        case 9: return 'September';
        case 10: return 'October';
        case 11: return 'November';
        case 12: return 'December';
        default: return '';
    }
};

export default util;
